// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3Pjfi","label":"Radio_label__eIVIR","checkMark":"Radio_checkMark__1Twxw","disabled":"Radio_disabled__37l3m"};